<template>
  <div>
    <!-- 水位设置 -->
    <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog" @closed="closed">
      <el-form ref="form" :rules="rules" :model="form" label-width="90px">
        <el-form-item label="站名:" required v-if="sttp === 'RR'">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stnm"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="站名:" required v-if="sttp === 'ZZ'">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stationName"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="所属乡镇:" required v-if="sttp === 'RR' ">
          <el-form-item prop="userName">
            <el-input :disabled="true" v-model="form.stlc"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="测站编码:" required v-if="sttp === 'ZZ' ">
          <el-form-item prop="stationstcd">
            <el-input :disabled="true" v-model="form.stationstcd"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="警戒水位:" required v-if="sttp === 'ZZ' ">
          <el-form-item prop="jjsw">
            <el-input v-model="form.jjsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="保证水位:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="bzsw">
            <el-input v-model="form.bzsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="左堤高程(m):" v-if="sttp  === 'ZZ'">
          <el-form-item prop="zdgc">
            <el-input v-model="form.zdgc" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="右堤高程(m):" v-if="sttp  === 'ZZ'">
          <el-form-item prop="ydgc">
            <el-input v-model="form.ydgc" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="警戒流量(m3/s):" v-if="sttp  === 'ZZ'">
          <el-form-item prop="jjll">
            <el-input v-model="form.jjll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="保证流量(m3/s):" v-if="sttp  === 'ZZ'">
          <el-form-item prop="bzll">
            <el-input v-model="form.bzll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="平滩流量(m3/s):" v-if="sttp  === 'ZZ'">
          <el-form-item prop="ptll">
            <el-input v-model="form.ptll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="高水位告警值:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="gswgjz">
            <el-input v-model="form.gswgjz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="大流量告警值:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="dllgjz">
            <el-input v-model="form.dllgjz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="枯警水位:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="kjsw">
            <el-input v-model="form.kjsw" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="枯警流量:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="kjll">
            <el-input v-model="form.kjll" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="启动预报水位标准:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="ybswbz">
            <el-input v-model="form.ybswbz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
         <el-form-item label="启动预报流量标准:" v-if="sttp  === 'ZZ'">
          <el-form-item prop="ybllbz">
            <el-input v-model="form.ybllbz" auto-complete="off"></el-input>
          </el-form-item>
        </el-form-item>
        <el-button @click ="onAdd(form.id)" type="primary" icon="el-icon-circle-plus" class="add-time" v-if="sttp === 'RR'">时段</el-button>
        <!-- 添加新增数据中的时间以下 -->
        <el-form ref='singleForm' class="time-floodlimit" v-for="(item,index) in singleData.floodLimit" :key="index" :model="item" label-width="90px">
          <el-form-item  label="时间分段:" required v-if="sttp  === 'RR'">
            <div class="time-block">
              <el-date-picker v-model="item.bgmd" required type="date" placeholder="开始日期" format=" MM-dd " value-format="MMdd">
              </el-date-picker>
              <div class="symbol">&nbsp;-&nbsp;</div>
              <el-date-picker v-model="item.edmd" required type="date" placeholder="结束日期" format=" MM-dd " value-format="MMdd">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="汛限水位:" required v-if="sttp  === 'RR'" >
            <el-form-item prop="floodLimit" id="floodLimit">
              <el-input v-model="item.fsltdz" required auto-complete="off"></el-input>
            </el-form-item>
          </el-form-item>
          <div class="delete-icon">
            <i class="el-icon-delete" @click="onDelete(item, index)" style="cursor:pointer"></i>
          </div>
        </el-form>
         <!-- 添加新增数据中的时间以上 -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import userTypes from '@/store/types/user'
export default {
  name: 'Scence',
  components: {
  },
  data () {
    return {
      diagShow: false,
      form: {},
      singleData: {
        floodLimit: []
      },
      rules: {
        vigilance: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        floodLimit: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        jjsw: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ]
      },
      sttp: '',
      stid: '',
      stcd: '',
      loading: false,
      diagTitle: '编辑'
    }
  },
  methods: {
    // 水位设置
    editWaterDialog (row) {
      if (row.sttp.includes('ZZ')) {
        this.diagTitle = '河道水位测站编辑'
        this.sttp = 'ZZ'
      } else if (row.sttp.includes('RR')) {
        this.diagTitle = '水库水位测站编辑'
        this.sttp = 'RR'
      }
      this.form = {}
      if (this.sttp === 'RR') {
        this.$store.dispatch(userTypes.BACK_STATION_WARN_WATER_INFO, { sid: '22', stid: row.id, pageIndex: 1, pageSize: 500 }).then(data => {
          this.singleData = Object.assign({ floodLimit: [] }, data.rows[0]) // 当水库floodlimit为空时
          this.stcd = this.singleData.stcd
        })
        this.stid = row.id
        this.form = row
        this.form = Object.assign({}, this.form) // 取消时
        this.Global.clearValidate(this, 'form')
        this.diagShow = true
        this.loading = false
      } else {
        this.$store.dispatch(userTypes.GET_RIVER_LIST_INFO, {
          sid: 22,
          stationId: row.stationId,
          pageIndex: 1,
          pageSize: 500,
          sttp: 'ZZ'
        }).then(data => {
          this.form = data.rows[0] || {
            stationId: row.stationId,
            stationNmae: row.stationNmae
          }
          this.Global.clearValidate(this, 'form')
          this.diagShow = true
          this.loading = false
        })
      }
    },
    onSave () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.sttp === 'RR') { // 水库水位保存
            let callbackVal = this.singleData.floodLimit.every(element => { // 新增时段，起始时间为空不执行
              return element.bgmd !== '' || element.enmd !== ''
            })
            if (callbackVal) {
              this.$store.dispatch(userTypes.BATCH_SAVE_STATION_WARN_WATER_INFO, { stid: this.stid, list: this.singleData.floodLimit }).then(() => {
                this.$notify.success({ title: '成功', message: '编辑成功.' })
                this.diagShow = false
                this.onLoadData()
                this.loading = false
              })
            } else {
              this.$notify.error({ title: '保存失败', message: '起始时间不能为空' })
              this.loading = false
            }
          } else { // 河道保存
            let user = Object.assign({}, this.form)
            this.$store.dispatch(userTypes.SAVE_RIVER_LIST_INFO, user).then(() => {
              this.$notify.success({ title: '成功', message: '编辑成功.' })
              this.diagShow = false
              this.onLoadData()
              this.loading = false
            })
          }
        }
      })
    },
    // 添加时间段设置
    onAdd (key) {
      this.singleData.floodLimit.push({
        id: '',
        stid: this.stid,
        stcd: this.stcd,
        fsltdz: '', // 汛限水位
        bgmd: '',
        enmd: ''
      })
    },
    // 删除对应时间段
    onDelete (item, i) {
      var index = this.singleData.floodLimit.indexOf(item)
      if (index !== -1) {
        this.singleData.floodLimit.splice(index, 1)
      }
    },
    closed () {
      this.form = {}
      this.singleData = {
        floodLimit: []
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.scence /deep/ .el-dialog__body {
  overflow: hidden !important;
}
/deep/ .el-form{
  width: 100% !important;
  .el-form-item__content{
    width: auto!important;
    .el-input{
      width: 200px!important;
    }
  }
}
/deep/.el-form-item {
  width: 50% !important;
  float: left;
}
/deep/ .el-form-item__label{
  width: 130px !important;
}
.skt{
  height: calc(100% - 80px) !important;
}
.tabs{
  margin-bottom: 10px;
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  .country{
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
    .countryon, .categoryon{
      border-radius: 15px;
      background-color: #fda72c;
      color: #ffffff
    }
    span{
      padding: 4px 15px;
    }
  }
}
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.operation{
  margin: 0 auto !important;
  width: 6.25rem;
  height: 100%;
}
// 水位时间设置增加样式
.add-time{
  position: absolute;
  // left: 25rem;
  top: 2.61rem;
  right: 1rem;
}
.time-block {
  display:flex;
  /deep/ .el-date-picker{
    margin-right: 10px;
    margin-left: 20px;
  }
  .symbol {
    margin-left:5px;
    margin-right:5px
  }
  /deep/ .el-date-editor.el-input {
    width: 150px !important;
  }
}
.time-floodlimit  #floodLimit {
 width: 50% !important;
}
.time-floodlimit .delete-icon {
  height: 62px;
  position: relative;
  top: 48px;
  pointer-events: none;
}
.time-floodlimit .el-icon-delete{
  pointer-events: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  height: 14px;
}
/deep/ .el-dialog__footer {
  margin-top: 0!important;
}
</style>
